import "./toggle.scss";

const Toggle = (props) => {
  console.debug("Rendering toggle: ", props.name);

  const {
    error,
    displayError,
    message,
    helpertext,
    label,
    tooltip,
    ...inputProps
  } = props;

  return (
    <fieldset className="input input-toggle">
      <legend className="label">{props.label || ""}</legend>
      {props.options &&
        props.options.map((o) => (
          <div key={`${props.name}_${o.value}`}>
            <input
              type="radio"
              name={props.name}
              key={`${props.name}_${o.value}`}
              id={`${props.name}_${o.value}`}
              options={props.options}
              value={o.value}
              checked={props.value === o.value}
              onChange={props.onChange}
            />
            <label className="group" htmlFor={`${props.name}_${o.value}`} style={{padding: "0 var(--space-8) 0 var(--space-8)"}}>
              <span className="label-inline">{o.label}</span>
            </label>
          </div>
        ))}
    </fieldset>
  );
};

export default Toggle;
